#import '../fragments/email-sequence-template-full-fragment.graphql'

query GetEmailTemplateGroup(
    $id: ID!
    $creatorIds: [ID!]
    $search: String
    $onlyArchived: Boolean
    $includeShared: Boolean
    $includeUnsharedFromOthers: Boolean
) {
    emailSequenceTemplateGroup(id: $id) {
        id
        emailSequenceTemplates(
            creatorIds: $creatorIds
            onlyArchived: $onlyArchived
            includeShared: $includeShared
            search: $search
            includeUnsharedFromOthers: $includeUnsharedFromOthers
        ) {
            ...EmailSequenceTemplateFullFragment
        }
    }
}
